<template>
    <tr>
        <td>
            <checkbox-input
                v-model="isSelected"
                name="address_ids[]"
                :value="address.id"
            />
        </td>
        <td>
            {{ address.full_address_with_apartment_number }}
        </td>
    </tr>
</template>

<script>
    export default {
        props: {
            address: {
                required: true,
                type: Object,
            },
            selectedAddresses: {
                type: Array,
                required: true,
            },
            toggleAddress: {
                type: Function,
                required: true,
            },
        },
        computed: {
            isSelected: {
                set() {
                    return this.toggleAddress(this.address);
                },
                get() {
                    return this.selectedAddresses.indexOf(this.address.id) > -1;
                },
            },
        },
    };
</script>
